import { LANGUAGES, isLanguageCode, type LanguageCode } from '../languages';
import { useStrings } from '../i18n/context';

interface Props {
  readonly value: LanguageCode;
  readonly onChange: (code: LanguageCode) => void;
}

/** "The language I speak": what the interpreter listens for and what I hear others in. */
export function LanguageSelect({ value, onChange }: Props) {
  const strings = useStrings();
  return (
    <div className="field">
      <label htmlFor="vm-language">{strings.languageLabel}</label>
      <select
        id="vm-language"
        value={value}
        aria-describedby="vm-language-hint"
        onChange={(event) => {
          if (isLanguageCode(event.target.value)) onChange(event.target.value);
        }}
      >
        {LANGUAGES.map((language) => (
          <option key={language.code} value={language.code} lang={language.code}>
            {language.nativeName}
          </option>
        ))}
      </select>
      <p id="vm-language-hint" className="field__hint">
        {strings.languageHint}
      </p>
    </div>
  );
}
